export enum EstatePlanningTab {
  Checklist = 'Checklist',
  Beneficiaries = 'Beneficiaries',
  EstateFlow = 'Estate Flow',
}

// TODO - 263256 - remove
export enum LegacyEstatePlanningTab {
  Checklist = 'Checklist',
  Beneficiaries = 'Beneficiaries',
}

export enum EstatePlanningDocumentType {
  Will,
  PowerOfAttorneyForHealthCareDecisions,
  PowerOfAttorneyForFinancialMatters,
  RevocableTrust,
  ExerciseOfPowerOfAppointment,
  MaritalPropertyAgreements,
  IrrevocableTrustInstruments,
  LLCOrPartnershipDocuments,
  CorporateDocuments,
  OtherDocuments,
}
